import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormData, PackageState } from "../../types/packageType";
import { Option } from "../../types/commonElements";

const initialState: PackageState = {
  formData: {
    packageName: "",
    amount: "",
    isGstCollected: false,
  },
  errors: {},
  selectOptions: {
    packageName: [],
  },
  packageTable: [{ no: 0, procedure: "", no_of_session: "", amount: "" }],
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<FormData>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectOptions: (
      state,
      action: PayloadAction<{ [key: string]: Option[] }>
    ) => {
      state.selectOptions = action.payload;
    },
    setTable: (state, action: PayloadAction<any>) => {
      state.packageTable = action.payload;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = initialState.formData;
      state.errors = {};
      state.packageTable = [
        { no: 0, procedure: "", no_of_session: "", amount: "" },
      ];
    },
    submitForm: (state) => {},
  },
});

export const {
  setFormData,
  setErrors,
  clearErrors,
  clearForm,
  submitForm,
  setSelectOptions,
  setTable,
} = packageSlice.actions;

export default packageSlice.reducer;
